
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"19.5","fill":"none","stroke":"currentColor"}}),_c('circle',{attrs:{"cx":"12","cy":"20","r":"2"}}),_c('circle',{attrs:{"cx":"20","cy":"20","r":"2"}}),_c('circle',{attrs:{"cx":"28","cy":"20","r":"2"}})])
          )
        }
      }
    